import { useCallback } from 'react'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'

export const useOAuthApps = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account, isLoading: accountIsLoading } = useGetAccountQuery({ accountId })
  const restrictions = account?.data?.enterpriseConfig.integrationsConfig.restrictions
  // Enterprise-controlled gate for creating OAuth2 apps. Only hierarchy-managed accounts carry a concrete value:
  // `false` (disabled, the hierarchy default) hides creation, `true` enables it. Non-hierarchy accounts stay `null`
  // and fall back to their quota (the directory's separate oauth2Enabled check). So: blocked only on an explicit `false`.
  const isAppCreationEnabled = account?.data?.enterpriseConfig.integrationsConfig.oauthAppCreationEnabled !== false
  const isOAuthAppAllowed = useCallback(
    (oauthAppId: string): boolean => {
      if (restrictions && (restrictions.allowedIntegrations?.length || restrictions.deniedIntegrations?.length)) {
        if (restrictions.allowedIntegrations?.length) {
          return restrictions.allowedIntegrations.includes(oauthAppId) && !restrictions.deniedIntegrations.includes(oauthAppId)
        }
        return !restrictions.deniedIntegrations.includes(oauthAppId)
      }
      return true
    },
    [restrictions],
  )

  return {
    isOAuthAppAllowed,
    isAppCreationEnabled,
    accountIsLoading,
  }
}
